import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { ApiUrl } from '../../../services/ApiRest';
import { ToastContainer, toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { RequestProductsSelect } from '../../guide/selects/RequestProductsSelect';
import Cookies from 'universal-cookie/es6';
import { useNavigate } from 'react-router-dom';
const cookies = new Cookies();
const userId = cookies.get('uid');
// import { BrowserRouter as Router } from 'react-router-dom';
console.log('USER ID', userId);
export const SalesProductsInventory = () => {
    const [requestProductToAddSelected, setrequestProductToAddSelected] = useState(null);
    const [resetSelect, setResetSelect] = useState(false);
    const [reloadChild, setReloadChild] = useState(false);
    const [selectDisabled, setselectDisabled] = useState(true);
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [passengerExistCi, setpassengerExistCi] = useState('');
    const [passengerNewCi, setpassengerNewCi] = useState('');
    const [showForm, setShowForm] = useState(false);
    const [total, setTotal] = useState(0);
    const [data, setdata] = useState([]);
    const [passengerCiValue, setpassengerCiValue] = useState();
    const [passengerStatusValue, setpassengerStatusValue] = useState();
    const [passengerSFValue, setpassengerSFValue] = useState();
    const [passengerCiValueDataList, setpassengerCiValueDataList] = useState();
    const [passengerStatusValueDataList, setpassengerStatusValueDataList] = useState(); //setpassengerSFValueDataList
    const [passengerSFValueDataList, setpassengerSFValueDataList] = useState();
    const [passengerSaleTypeValueDataList, setpassengerSaleTypeValueDataList] = useState();
    const [productToDelete, setProductToDelete] = useState(null);
    const [productSelected, setproductSelected] = useState([]);
    const [showForm2, setShowForm2] = useState(false);
    const [showForm3, setShowForm3] = useState(false);
    const [showForm4, setShowForm4] = useState(false);
    const [showForm5, setShowForm5] = useState(false);
    const [showForm6, setShowForm6] = useState(false);
    const [showForm7, setShowForm7] = useState(true);
    const [showForm8, setShowForm8] = useState(true);
    const [showForm9, setShowForm9] = useState(true);
    const [showForm10, setShowForm10] = useState(false);
    const [showForm11, setShowForm11] = useState(true);
    const [showForm12, setShowForm12] = useState(false);
    const [showForm13, setShowForm13] = useState(true);
    const navigate = useNavigate();
    const [passengerCiFinalConsumer, setpassengerCiFinalConsumer] = useState();
    const [secuentialBillId, setsecuentialBillId] = useState();
    const [secuentialBillIdInProcess, setsecuentialBillIdInProcess] = useState();
    const [secuentialBillCiInProcess, setsecuentialBillCiInProcess] = useState();
    const [ciFinalConsumer, setciFinalConsumer] = useState(9999999999);
    const [secuentialNew, setsecuentialNew] = useState();
    const [formD, setformD] = useState({
        ci: '',
        name: '',
        phone: '',
        address: '',
        correo: ''
    });
    const [formD2, setformD2] = useState({
        quantity_prod: ''
    });

    const onSearch = async () => {
        setButtonDisabled(true);
        const formData = new FormData();
        formData.append("ci", formD.ci);
        // Verificar el valor de formD.ci
        if (formD.ci === '' || formD.ci === null) {
            toast.error("Ingrese un número de cédula", { position: toast.POSITION.BOTTOM_RIGHT });
        } else {
            // console.log('Valor de ci en formD:', formD.ci);
            try {
                const response = await axios.post(`${ApiUrl}passenger-sale-products-search`, { ci: formD.ci });
                const resp = response.data;
                console.log('Resultado de la búsqueda:', resp);
                if (resp && resp.passenger) {
                    console.log('Nombre del pasajero:', resp.passenger.name);
                    console.log('Valor passengerCiValue', resp.passenger.ci);
                    // if (formD.name === '' || formD.phone === '' || formD.address === '' || formD.correo === '') {
                    if ((resp.passenger.name === null || resp.passenger.phone == null || resp.passenger.address === null || resp.passenger.correo === null) || (resp.passenger.name === '' || resp.passenger.phone == '' || resp.passenger.address === '' || resp.passenger.correo === '')) {
                        // Actualizar el estado utilizando una función de actualización del estado
                        setformD(prevFormD => ({
                            ...prevFormD,
                            name: resp.passenger.name,
                            phone: resp.passenger.phone,
                            address: resp.passenger.address,
                            correo: resp.passenger.correo
                        }));
                        setButtonDisabled(false);
                        dataList();
                        setpassengerExistCi(resp.passenger.passenger_id);
                        console.log('Valor de passenger_idsdsds', resp.passenger.passenger_id);
                        setShowForm7(false);
                        setShowForm6(false);
                        setShowForm12(true);


                    } else {
                        // Actualizar el estado utilizando una función de actualización del estado
                        setformD(prevFormD => ({
                            ...prevFormD,
                            name: resp.passenger.name,
                            phone: resp.passenger.phone,
                            address: resp.passenger.address,
                            correo: resp.passenger.correo
                        }));
                        setButtonDisabled(true);
                        dataList();
                        console.log('Valor de passenger_idsdsds TODOOOO:', resp.passenger.passenger_id);
                        setShowForm7(false);
                        setShowForm6(false);
                        setShowForm8(false);
                        setShowForm12(true);

                    }
                    setShowForm(true);
                } else {
                    toast.error("Cliente no registrado en el sistema. Ingrese su información", { position: toast.POSITION.BOTTOM_RIGHT });
                    // Limpiar los campos del formulario
                    setformD(prevFormD => ({
                        ...prevFormD,
                        name: '',
                        phone: '',
                        address: '',
                        correo: ''
                    }));
                    setButtonDisabled(false);
                    setShowForm(false);
                    setShowForm6(false);
                }
                if (resp && resp.passenger) {
                    const ciSecuentialBill = formD.ci;
                    console.log('passengerCiValue SSSSS:', ciSecuentialBill);
                    console.log('passenger SALE TYPE Value SSSSS:', passengerSaleTypeValueDataList);
                    const formData = new FormData();
                    formData.append("description", `Fact`);
                    // formData.append("passengerCiValue", passengerCiValue); // Nombre para el valor de passengerCiValue
                    formData.append("ciSecuentialBill", ciSecuentialBill); // Nombre para el valor de passengerCiValue
                    // formData.append("passengerStatusValue", passengerStatusValue); // Nombre para el valor de passengerStatusValue
                    formData.append("passengerStatusValue", passengerStatusValue); // Nombre para el valor de passengerStatusValue
                    console.log('passengerCiValue AAAA:', passengerCiValue);
                    console.log('passengerCiValue AAAA:', passengerStatusValue);
                    console.log('Datos enviados al backend AGREGADOSSSS secuential_bill:', Object.fromEntries(formData));

                    const response = await axios.post(ApiUrl + 'secuential-bill-sale-products-create', formData);
                    const resp = response.data;
                    console.log('Valor FACT IN :', resp);
                    setsecuentialBillId(resp.secuential_bill_id);
                    setsecuentialBillIdInProcess(resp.valueClientInProcess);
                    setsecuentialBillCiInProcess(resp.valueCIClientInProcess);
                    setsecuentialNew(resp.valueClientInProcess);
                    console.log('IDnewinsertSecuentia Bill:', resp.secuential_bill_id);
                    console.log('valueClientInProcess Secuentia Bill:', resp.valueClientInProcess);
                    console.log('valueCIClientInProcess Secuentia Bill CI:', resp.valueCIClientInProcess);
                    console.log('onSEARCH P:', passengerStatusValue);
                }
            } catch (error) {
                console.log(error);
                toast.error("" + error + "  !", { position: toast.POSITION.BOTTOM_RIGHT });
            }
        }

    };

    const getFinalConsumerInfo = async () => {
        try {
            const response = await axios.post(`${ApiUrl}passenger-sale-products-search-consumer`, { ci: 9999999999 });
            const resp = response.data;
            console.log('consumidor devuelve:', resp);
            console.log('consumidor devuelve 22:', resp.passenger.ci);
            // console.log('consumidor devuelve 22 FS:', resp.passenger2.secuential_bill_id);
            // console.log('consumidor devuelve 22 FS:', resp.passenger2.status_sales_products);
            if (resp.passenger.ci) {
                setformD(prevFormD => ({
                    ...prevFormD,
                    ci: resp.passenger.ci,
                    name: resp.passenger.name,
                    phone: resp.passenger.phone,
                    address: resp.passenger.address,
                    correo: resp.passenger.correo
                }));
                console.log('quiero ver comsumidor DATA:', data);
                setButtonDisabled(true);
                dataList();
                setShowForm7(true);
                setShowForm6(false);
                setShowForm8(false);
                setShowForm2(false);
                setShowForm5(false);
                setShowForm10(true);
                // setShowForm11(false);
                console.log('ci consumidor:', resp.passenger.ci);
                setpassengerCiFinalConsumer(resp.passenger.ci);
                setShowForm6(false);
            } else {
                toast.error("No se encontró información del consumidor final", { position: toast.POSITION.BOTTOM_RIGHT });
            }
            var response2 = '';
            if (resp.passenger.ci) {
                // response2 = await axios.post(`${ApiUrl}request-complete-update-status/${requestCompleteProductsId}`);
                response2 = await axios.post(`${ApiUrl}passenger-sale-products-search-consumer-final`, { ci: 9999999999 });
                console.log('consumidor devuelve 99999 si EXISTE:', response2);
            }
            if (response2.data.passenger2 === null) {
                console.log('No hay consumidores en proceso');
            } else {
                const fsID = response2.data.passenger2.secuential_bill_id;
                console.log('fsID:', fsID);
                const fsStatus = response2.data.passenger2.status_sales_products;
                console.log('fsStatus:', fsStatus);
                const fsCi = response2.data.passenger2.passengers_ci;
                console.log('fsCi:', fsCi);
                const fsSaleType = response2.data.passenger2.sale_type;
                console.log('fsSaleType:', fsSaleType);
                if (fsCi === 9999999999 || fsStatus === 'P' || fsSaleType === 'Inventario') {
                    toast.error("Consumidor Final en proceso", { position: toast.POSITION.BOTTOM_RIGHT });
                    setShowForm(false);
                    setShowForm6(false);
                    setShowForm7(true);
                    setShowForm10(false);
                    setShowForm11(true);
                    return;
                } else {
                    setShowForm6(false);
                    setShowForm7(true);
                }
            }
        } catch (error) {
            console.log(error);
            toast.error("" + error + "  !", { position: toast.POSITION.BOTTOM_RIGHT });
        }
    };

    const onSearchFinalConsumer = async () => {
        const statusForFC = passengerStatusValue;
        console.log('statusForFC909090:', statusForFC);
        const ciForFC = passengerCiValue;
        console.log('CI PARA CONSUMIDOR90909', ciForFC);
        console.log('CI PARA CONSUMIDOR 55555', ciFinalConsumer);
        const secuentialBillProcces = secuentialNew;
        console.log('secuentialBillProcces909090909090909090', secuentialBillProcces);

        dataList();
        setButtonDisabled(true);
        getFinalConsumerInfo();
    };

    const onSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData();
        formData.append("ci", formD.ci);
        formData.append("name", formD.name);
        formData.append("phone", formD.phone);
        formData.append("address", formD.address);
        formData.append("correo", formD.correo);
        formData.append("city", 'Riobamba');
        // Verificar el valor de formD.ci
        console.log('Valor de ci en formD:', formD.ci);
        try {
            const response = await axios.post(ApiUrl + 'passenger-sale-products-create', formData);
            const resp = response.data;
            console.log('Valor :', resp);

            if (resp.success) {
                toast.success("Cliente agregado exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });
                setButtonDisabled(true);
                setShowForm(true);
                setpassengerNewCi(resp.passenger_ci);
                console.log('Valor de passenger_id Nuevo', resp.passenger_id);
                dataList();
                setShowForm7(false);
                setShowForm9(false);

            } else {
                toast.error("Cliente NO se ha agregado", { position: toast.POSITION.BOTTOM_RIGHT });
            }
            if (resp && resp.passenger_id) {
                const ciSecuentialBill = formD.ci;
                console.log('passengerCiValue SSSSS NUEVO CLIENT:', ciSecuentialBill);
                const formData = new FormData();
                formData.append("description", `Fact`);
                formData.append("passengerCiValue", ciSecuentialBill); // Nombre para el valor de passengerCiValue
                formData.append("passengerStatusValue", passengerStatusValue); // Nombre para el valor de passengerStatusValue
                console.log('passengerCiValue AAAA NUEVO CLIENT:', passengerCiValue);
                console.log('passengerCiValue AAAA NUEVO CLIENT:', passengerStatusValue);
                console.log('Datos enviados al backend AGREGADOSSSS secuential_bill NUEVO CLIENT:', Object.fromEntries(formData));

                const response = await axios.post(ApiUrl + 'secuential-bill-sale-products-create', formData);
                const resp = response.data;
                console.log('Valor FACT IN :', resp);
                setsecuentialBillId(resp.secuential_bill_id);
                setsecuentialBillIdInProcess(resp.valueClientInProcess);
                setsecuentialBillCiInProcess(resp.valueCIClientInProcess);
                console.log('IDnewinsertSecuentia Bill Consumi:', resp.secuential_bill_id);
                console.log('valueClientInProcess Secuentia Bill NUEVO CLIENT IN PROCESO:', resp.valueClientInProcess);
                console.log('valueClientInProcess Secuentia Bill NUEVO CLIENT IN PROCESO:', resp.valueClientInProcess);
                console.log('valueCIClientInProcess Secuentia Bill CI NUEVO CLIENT IN PROCESO:', resp.valueCIClientInProcess);
                console.log('onSEARCH P NUEVO CLIENT:', passengerStatusValue);
                setShowForm12(true);
            }

        } catch (error) {
            console.log(error);
            toast.error("" + error + "!", { position: toast.POSITION.BOTTOM_RIGHT });
        }
    };

    const onSubmitSale = async (event) => {
        event.preventDefault();
        if (requestProductToAddSelected && requestProductToAddSelected.value) {
            const selectedProductId = requestProductToAddSelected.value.product_warehouses_id;
            const selectedProductLabel = requestProductToAddSelected.label;
            if (!selectedProductId || !selectedProductLabel) {
                toast.error("Por favor, selecciona un producto válido.", { position: toast.POSITION.BOTTOM_RIGHT });
                return;
            }
            const quantityToAdd = formD2.quantity_prod;
            const ciValue = formD.ci;
            console.log('CANTIDAD DE PRODUCTOS:', quantityToAdd);
            console.log('CANTIDAD DE PRODUCTOS DIRECTo:', formD2.quantity_prod);
            console.log('CANTIDAD DE CI PARA VENTA:', ciValue);
            // Validar que la cantidad sea un número positivo
            if (!quantityToAdd || isNaN(quantityToAdd) || quantityToAdd <= 0) {
                toast.error("Por favor, ingresa una cantidad válida.", { position: toast.POSITION.BOTTOM_RIGHT });
                return;
            }
            const availableQuantity = parseInt(selectedProductLabel.match(/\((\d+)\)/)[1], 10);
            // Validar que la cantidad a agregar no exceda la cantidad disponible
            if (quantityToAdd > availableQuantity) {
                toast.error("La cantidad solicitada excede la disponibilidad del producto.", { position: toast.POSITION.BOTTOM_RIGHT });
                return;
            }
            if (ciValue === '' || ciValue === null) {
                toast.error("No existe información del cliente.", { position: toast.POSITION.BOTTOM_RIGHT });
                return;
            }

            const formData = new FormData();
            console.log('secuentialBillIdInProcess OnSubmitSale:', secuentialBillIdInProcess);
            console.log('secuentialBillIdOnSubmitSale:', secuentialBillId);
            console.log('Type SALE OnSubmitSale:', passengerSaleTypeValueDataList);

            formData.append("passengers_ci", ciValue);
            formData.append("user_id", userId);
            formData.append("quantity_prod", quantityToAdd);
            formData.append("status_sales_products", 'P');
            formData.append("sale_type", 'Inventario');
            formData.append("product_warehouse_id", selectedProductId);
            if (passengerStatusValue === 'P' && ciValue === secuentialBillCiInProcess && passengerSaleTypeValueDataList === 'Inventario') {
                formData.append("secuential_bill_id", secuentialBillIdInProcess);

            } else {
                formData.append("secuential_bill_id", secuentialBillId);
            }
            // Obtener la fecha actual en el formato deseado y agregarla a formData
            const currentDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
            formData.append("sale_date", currentDate);
            console.log('productors id:', selectedProductId);
            try {
                const response = await axios.post(ApiUrl + 'sale-products-create', formData);
                const resp = response.data;
                if (resp.success) {
                    toast.success("Producto agregado exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });
                    dataList();
                    setReloadChild(!reloadChild);
                    setformD2({
                        ...formD2,
                        quantity_prod: '' // Limpiar la cantidad después de agregar el producto //classList
                    });
                    setButtonDisabled(true);
                    setShowForm6(true);
                    setShowForm12(true);

                } else {
                    toast.error("El Producto no se ha agregado", { position: toast.POSITION.BOTTOM_RIGHT });
                }

            } catch (error) {
                console.log(error);
                toast.error("" + error + "  !", { position: toast.POSITION.BOTTOM_RIGHT });
            }
            setResetSelect(true);
            setResetSelect(false);

        } else {
            toast.error("Por favor, selecciona un producto antes de continuar", { position: toast.POSITION.BOTTOM_RIGHT });
        }
    };

    const onInputChange = ({ target }) => {
        const { name, value } = target;
        setformD({
            ...formD,
            [name]: value
        })
    }

    const onInputChange2 = (event) => {
        setformD2({
            ...formD2,
            [event.target.name]: event.target.value,
        });
    };

    const dataList = async () => {
        try {
            const ci1 = formD.ci;
            console.log('ci cicicici:', ci1);
            setpassengerCiValue(ci1);
            if (ci1 === null || ci1 === '') {
                console.log('En espera de datos');

            } else {

                const response = await axios.get(ApiUrl + `sale-products-list/${userId}/${ci1}`);
                const responseData = response.data;
                setdata(responseData);
                console.log('DATALIST LISTADO:', responseData);

                // Calcular la suma total
                const newTotal = responseData.reduce((acc, item) => acc + parseFloat(item.total_price_sale), 0);
                setTotal(newTotal);

                // console.log('status:',responseData.status_sales_products);

                // Mostrar solo el estado de cada elemento
                responseData.forEach(item => {
                    console.log('status sss  DataList:', item.status_sales_products);
                    setpassengerStatusValueDataList(item.status_sales_products);
                    setShowForm6(true);
                });
                responseData.forEach(item => {
                    console.log('CIII sssNOTICE DataList:', item.passengers_ci);
                    setpassengerCiValueDataList(item.passengers_ci);
                });
                responseData.forEach(item => {
                    console.log('SF id sss desde dataList:', item.secuential_bill_id);
                    setpassengerSFValueDataList(item.secuential_bill_id);
                    setShowForm6(true);
                });

            }
        } catch (error) {
            console.error(error);
        }
    };

    const deleteSaleProduct = async (id) => {
        console.log("ID a eliminar:", id);
        await axios.post(ApiUrl + `sale-products-delete/${id}`)
            .then(resp => {
                toast.success("Producto eliminado exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });
                deleteTable();
                dataList();
                setReloadChild(!reloadChild);
                console.log('AQUI DATA DELETER:', data.length === 1);
                if (data.length === 1) {
                    setShowForm6(false);
                }
            })
            .catch(e => {
                console.log(e);
            });
        setProductToDelete(null);
    };

    const deleteTable = () => {
        const script1 = document.createElement("script");
        script1.src = `/assets/dataTable/datatable-destroy.js`;
        script1.async = true;
        document.body.appendChild(script1);
    }
  

    const aceptarModal = async () => {
        // Realizar la actualización del estado en el servidor
        try {
            var response1 = '';
            const ciInput = formD.ci;
            const saleProducts = passengerStatusValue;            
            if (passengerStatusValueDataList === undefined || ciInput === undefined) {
                toast.error("No existen productos en listado. Por favor, selecciona un producto.", { position: toast.POSITION.BOTTOM_RIGHT });
                return;
            } else {
                // Verificar si las variables tienen valor antes de usarlas
                if (ciInput != null || ciInput != undefined || ciInput != '') {
                    // if (ciInput) {
                    if (secuentialBillId != undefined) {
                        response1 = await axios.post(`${ApiUrl}sale-product-update-status/${ciInput}/${secuentialBillId}`);
                    } else if (secuentialBillIdInProcess != undefined) {
                        response1 = await axios.post(`${ApiUrl}sale-product-update-status/${ciInput}/${secuentialBillIdInProcess}`);
                    } else {
                        console.log('No se ha vendido');
                    }
                    // response1 = await axios.post(`${ApiUrl}sale-product-update-status/${ciInput}`);
                    console.log('ResponseACCEPT:', response1);
                    toast.success("Venta generada exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });
                    navigate('/administrativo/ventas-productos');
                } else {
                    toast.error("Error al generar venta", { position: toast.POSITION.BOTTOM_RIGHT });
                }
                // setShowForm5(false);
            }

            // INSERCION DE CUENTA TOTAL 

            console.log('Valor de ciInput Inventario AceptarModal:', ciInput);
            console.log('Valor de saleProducts Inventario AceptarModal:', saleProducts);
            console.log('Valor de saleProducts Inventario AceptarModal DataList:', passengerStatusValueDataList);
            console.log('Valor de secuencial final NEW AceptarModal:', secuentialBillId);
            console.log('Valor de secuencial final PROCESS AceptarModal:', secuentialBillIdInProcess);
            console.log('Valor de secuencial final Dato en Proceso PROCESS AceptarModal:', secuentialBillCiInProcess);
            console.log('Valor de secuencial TOTAL AceptarModal:', total);
            console.log('Valor de secuencial Type Sale AceptarModal:', passengerSaleTypeValueDataList);
            console.log('Valor de secuencial CI AceptarModal:', passengerCiValueDataList);

            const formData = new FormData();

            if (passengerStatusValueDataList === 'P' && ciInput === passengerCiValueDataList && passengerSaleTypeValueDataList === 'Inventario') {
                formData.append("secuential_bill_id", secuentialBillIdInProcess);

            } else {
                formData.append("secuential_bill_id", secuentialBillId);

            }
            formData.append("total_price", total);
            console.log('Datos enviados al backend AGREGADOSSSS secuential_bill:', Object.fromEntries(formData));
            const response = await axios.post(ApiUrl + 'total-account-sale-products-create', formData);
            const respTC = response.data;
            console.log('Valor FACT IN :', respTC);

        } catch (error) {
            console.error(error);
            toast.error("Error al generar venta", { position: toast.POSITION.BOTTOM_RIGHT });
        }
    };

    const onDataListUpdate = () => {
        console.log("Actualización de datos solicitada");
    };

    const dataList2 = async () => {
        try {
            const response = await axios.get(ApiUrl + `sale-products-list-notice`);
            const responseData = response.data;
            setdata(responseData);
            console.log('DATALIST LISTADO NOTICEEE:', responseData);

            // Mostrar solo el estado de cada elemento
            responseData.forEach(item => {
                console.log('status sssNOTICE:', item.status_sales_products);
                setpassengerStatusValue(item.status_sales_products);
            });
            // Mostrar solo el estado de cada elemento  
            responseData.forEach(item => {
                console.log('CIII sssNOTICE:', item.passengers_ci);
                setpassengerCiValue(item.passengers_ci);
            });
            responseData.forEach(item => {
                console.log('TypeSale id sss NOTICE:', item.sale_type);
                setpassengerSaleTypeValueDataList(item.sale_type);
            });

        } catch (error) {
            console.error(error);
        }
    };

    const handleContinueButtonClick = () => {
        setShowForm3(true);
        setShowForm4(false);
        setShowForm5(true);
    };

    const DeleteSaleModal = async () => {
        // Realizar la actualización del estado en el servidor
        try {
            var response1 = '';
            const ciInput = formD.ci;
            const saleProducts2 = passengerStatusValue;
            const secuentialBillIdValue = passengerSFValue;
            console.log('Valor de ciInput ELIMINAR MODAL:', ciInput);
            console.log('Valor de STATUS ELIMINAR MODAL:', saleProducts2);
            console.log('Valor de saleProducts Inventario AceptarModal DataList:', passengerStatusValueDataList);
            console.log('Valor de secuencial final NEW ELIMINAR MODAL:', secuentialBillId);
            console.log('Valor de secuencial final PROCESS ELIMINAR MODAL:', secuentialBillIdInProcess);
            // console.log('Valor de secuentialBillIdValue ELIMINAR MODAL Process:', secuentialBillIdValue);
            if (passengerStatusValueDataList === undefined || ciInput === undefined) {
                toast.error("No existen productos en listado. Por favor, selecciona un producto.", { position: toast.POSITION.BOTTOM_RIGHT });
                return;
            } else {
                // Verificar si las variables tienen valor antes de usarlas
                if (ciInput != null || ciInput != undefined || ciInput != '') {
                    // response1 = await axios.post(`${ApiUrl}sale-products-delete-complete/${ciInput}/${secuentialBillIdValue}`);

                    if (secuentialBillId != undefined) {
                        response1 = await axios.post(`${ApiUrl}sale-products-delete-complete/${ciInput}/${secuentialBillId}`);
                    } else if (secuentialBillIdInProcess != undefined) {
                        response1 = await axios.post(`${ApiUrl}sale-products-delete-complete/${ciInput}/${secuentialBillIdInProcess}`);
                    } else {
                        console.log('No se ha vendido');
                    }
                    toast.error("Venta cancelada", { position: toast.POSITION.BOTTOM_RIGHT });
                    dataList();
                    setReloadChild(!reloadChild);
                    navigate('/administrativo/ventas-productos');
                    // setShowForm6(false);
                    // setShowForm7(true);
                } else {
                    toast.error("Error al generar venta", { position: toast.POSITION.BOTTOM_RIGHT });
                }
                // setShowForm5(false);
                // setShowForm2(false);
            }
        } catch (error) {
            console.error(error);
            toast.error("Error al generar venta", { position: toast.POSITION.BOTTOM_RIGHT });
        }
    };

    const cancelSaleProduct = async () => {
        console.log("ID a cancelar:", secuentialBillId);
        await axios.post(ApiUrl + `sale-products-cancel/${secuentialBillId}`)
            .then(resp => {
                toast.success("Venta cancelada exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });
                deleteTable();
                dataList();
                setReloadChild(!reloadChild);
                // Limpiar los campos del formulario
                setformD(prevFormD => ({
                    ...prevFormD,
                    ci: '',
                    name: '',
                    phone: '',
                    address: '',
                    correo: ''
                }));
                navigate('/administrativo/ventas-productos');

            })
            .catch(e => {
                console.log(e);
            });
        setProductToDelete(null);
        // setShowForm(false);
        // setShowForm7(true);
    };

    useEffect(() => {
        dataList();
    }, []);

    useEffect(() => {
        dataList2();
        console.log('ererer', passengerStatusValue);
        // Verificar si passengerStatusValue tiene un valor
        if (passengerStatusValue !== undefined) {
            if (passengerStatusValue === 'P') {
                setShowForm2(true);
                setShowForm3(false);
                setShowForm4(true);
                setShowForm5(false);
                setShowForm10(false);
                setShowForm11(false);
            }

        } else {
            setShowForm3(true);
            // alert('bbbbb');
        }
    }, [passengerStatusValue]);

    return (
        <div>
            <div className='row'>
                <div className='col-12 '>
                    <div className="card">
                        <div className="card-header">
                            VENTA DE INVENTARIO
                        </div>
                    </div>
                    {/* <div className="d-flex justify-content-end"> */}
                    <br></br>
                    <div className="d-flex justify-content">
                        {
                            showForm13 && (
                                <Link to={'../ventas-productos'}>                                    
                                    <button type="button" className="btn btn-secondary btn-lg">Regresar</button>&nbsp;
                                </Link>
                            )}
                        {/* {
                            showForm12 && (
                                <button data-bs-toggle="modal" data-bs-target="#modalTrash2" className="btn btn-secondary btn-lg" > Cancelar </button>
                            )} */}
                    </div>


                    <br></br>
                    {passengerStatusValue === 'P' && showForm2 && (
                        <center><div>
                            <center><h4>Existe una venta en Proceso con número de cédula:<b> {passengerCiValue}.</b> Para continuar el proceso, dar clic en el botón "Continuar".</h4></center>
                        </div></center>
                    )}
                    {passengerStatusValue === 'P' && showForm11 && (
                        <center><div>
                            <center><h4>Consumidor Final: Proceso</h4></center>
                        </div></center>
                    )}
                    {showForm10 && (
                        <center><div>
                            <center><h4>Consumidor Final: Nuevo. Para continuar dar clic en el boton "Buscar"</h4></center>
                        </div></center>
                    )}
                    <br></br>
                    {passengerStatusValue === 'P' && showForm4 && (
                        <div>
                            <center><button type="button" className="btn btn-success" style={{ width: '200px' }} onClick={handleContinueButtonClick}>Continuar</button></center>
                        </div>
                    )}

                    {passengerStatusValue === 'P' && showForm5 && (
                        <div>
                            <h5>Digite el número de cédula que muestra la advertencia, en el casillero de "Cédula de Identidad" y dar clic en el botón Buscar.</h5>
                        </div>
                    )}
                    {showForm3 && (
                        <form onSubmit={onSubmit}>
                            <div className='row'>
                                <label>Cédula de Identidad</label>
                                <div className='col-12 col-sm-10'>
                                    <div className="form-group">
                                        <input type="text" name='ci' className="form-control" pattern="\d*" maxLength="10" placeholder='' required value={formD.ci} onChange={onInputChange} />
                                    </div>
                                </div>
                                {showForm7 && (
                                    <div className='col-12 col-sm-2'>
                                        <div className="d-flex align-items-end"> {/* Contenedor para alinear verticalmente en la parte inferior */}
                                            <button type="button" className="btn btn-success" onClick={onSearch}>Buscar</button>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className='row'>
                                <div className='col-12 col-sm-8'>
                                    <div className="form-group">
                                        <label >Nombre y Apellido</label>
                                        <input type="text" name='name' className="form-control " placeholder='' required value={formD.name || ''} onChange={onInputChange}></input>
                                    </div>
                                </div>
                                <div className='col-12 col-sm-4'>
                                    <div className="form-group">
                                        <label >Teléfono</label>
                                        <input type="text" name='phone' className="form-control" pattern="\d*" maxLength="10" placeholder='' required value={formD.phone || ''} onChange={onInputChange}></input>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-12 col-sm-8'>
                                    <div className="form-group">
                                        <label >Dirección</label>
                                        <input type="text" name='address' className="form-control " placeholder='' required value={formD.address || ''} onChange={onInputChange}></input>
                                    </div>
                                </div>
                                <div className='col-12 col-sm-4'>
                                    <div className="form-group">
                                        <label >Correo electrónico</label>
                                        <input type="text" name='correo' className="form-control " placeholder='' required value={formD.correo || ''} onChange={onInputChange}></input>
                                    </div>
                                </div>
                            </div>
                            {showForm8 && (
                                <div>
                                    <button type="submit" className="btn btn-success" disabled={buttonDisabled}> Guardar </button> &nbsp;
                                    {
                                        showForm9 && (
                                            <button type="button" className="btn btn-success" onClick={onSearchFinalConsumer}>ConsumidorFinal</button>
                                        )}
                                    {/* <button type="submit" className="btn btn-success" disabled={buttonDisabled}> Actualizar </button> &nbsp; */}

                                </div>
                            )}
                        </form>
                    )}

                    <br></br>
                    {showForm && (
                        <div className="card-body">
                            <hr style={{ margin: '10px 0' }} />
                            <form onSubmit={onSubmitSale}>
                                <div className='row'>
                                    <div className='col-12 '>
                                        <div className='row'>
                                            <div className='col-2'>
                                                <div className="">
                                                    <label className="form-label">Cantidad</label>
                                                    <input type="number" name='quantity_prod' className="form-control" step="1" placeholder='000' required onChange={onInputChange2} value={formD2.quantity_prod}></input>
                                                </div>
                                            </div>
                                            <div className='col-8'>
                                                <div className="form-group">
                                                    <label >Seleccionar producto (Cantidad disponible)</label>
                                                    <RequestProductsSelect
                                                        requestProductSelect={requestProductToAddSelected}
                                                        setrequestProductSelect={setrequestProductToAddSelected}
                                                        resetValue={resetSelect}
                                                        onDataListUpdate={onDataListUpdate}
                                                        reload={reloadChild}
                                                        disabled={selectDisabled}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-2'>
                                                <div className="">
                                                    <center><label className="form-label">Añade producto</label></center>
                                                    {/* <center><button type="submit" className="btn btn-success" onClick={() => setResetSelect(false)}> Añadir </button></center> */}
                                                    <center><button type="submit" className="btn btn-success" onClick={() => setResetSelect(false)}> Añadir </button></center>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            <div className="card-body table-responsive">
                                <table className='table table-hover ' id="dataTable-ord-col1"  >
                                    <thead>
                                        <tr>
                                            <th>Cantidad</th>
                                            <th>Producto</th>
                                            <th>Categoría</th>
                                            <th>Precio unitario</th>
                                            <th>Precio total</th>
                                            <th>Fecha</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((item) => (
                                            <tr key={item.sales_products_id}>
                                                <td>{item.quantity_prod}</td>
                                                <td>{item.description_product_sale}</td>
                                                <td>{item.description_category}</td>
                                                <td>{item.unitary_price}</td>
                                                <td>{item.total_price_sale}</td>
                                                <td>{item.created_at}</td>
                                                <td>
                                                    {/* <button className='btn btn-outline-primary' data-bs-toggle="modal" data-bs-target="#exampleModaEdit"><i className="fas fa-edit"></i></button> */}
                                                    <button className='btn btn-outline-danger' data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => setProductToDelete(item.sales_products_id)}><i className="fas fa-trash-alt" aria-hidden="true"></i>  </button>
                                                </td>
                                            </tr>
                                        ))
                                        }
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan="4"><strong>Total:</strong></td>
                                            <td><strong>{total}</strong></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>

                        </div>
                    )}

                    {showForm6 && (
                        <div>
                            <button data-bs-toggle="modal" data-bs-target="#watchModalSale" className="btn btn-success btn-lg" > Vender </button> &nbsp;
                            <button data-bs-toggle="modal" data-bs-target="#modalTrash" className="btn btn-secondary btn-lg" > Cancelar </button> &nbsp;
                        </div>
                    )}
                </div >
            </div >

            {/* MODAL ELIMINAR PRODUCTO */}
            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Eliminar</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            Está seguro que desea eliminar<b>{productSelected.description}</b>
                        </div>
                        <div className="modal-footer">

                            <button type="button" className="btn btn-primary" onClick={() => deleteSaleProduct(productToDelete)} data-bs-dismiss="modal">Aceptar</button>
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal"  >Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* MODAL GENERAR VENTA */}
            <div className="modal fade" id="watchModalSale" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Generar Solicitud</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            ¿Estás seguro que deseas vender los siguientes productos?<b></b>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={aceptarModal}>Aceptar</button>
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal"  >Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* MODAL ELIMINAR VENTA */}
            <div className="modal fade" id="modalTrash" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Cancelar Venta</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            ¿Está seguro de cancelar venta?<b></b>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => {
                                DeleteSaleModal();
                                setResetSelect(false);
                            }}>Aceptar</button>
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* MODAL CANCELAR VENTA */}
            <div className="modal fade" id="modalTrash2" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Cancelar Venta</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            ¿Está seguro de cancelar venta?<b></b>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => {
                                cancelSaleProduct();
                                setResetSelect(false);
                            }}>Aceptar</button>
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer theme="colored" />
        </div >
    )
}